import { afterEviction, classifyRows, covers, leadDue, reopenInitial, sameSymbols, symbolSnapshot } from './rows';
export function sourceStatus(state) {
    if (state.source.status === 'awaiting-symbols' || state.source.status === 'awaiting-table-reset')
        return state;
    if (state.roundSymbols.length === 0 && state.activeSymbols.length === 0 && state.fetch.status !== 'in-flight') {
        return {
            ...state,
            source: { ...state.source, status: 'no-symbols' },
            initial: 'uncommitted',
            fetch: { status: 'idle' },
            pending: [],
            backfill: { status: 'none' },
            liveCatchUp: 'inactive',
            liveTopRecovery: false,
            liveDue: false,
            manualUp: false,
        };
    }
    const status = state.initial === 'committed' && state.caughtUp && state.reachedEnd ? 'exhausted' : 'active';
    return state.source.status === status ? state : { ...state, source: { ...state.source, status } };
}
export function startRound(state, previous, liveTop) {
    const additions = state.activeSymbols.filter((symbol) => !previous.includes(symbol));
    let token = state.nextToken;
    let next = {
        ...state,
        roundSymbols: state.activeSymbols,
        pending: [
            ...state.pending.filter((entry) => state.activeSymbols.includes(entry.symbol) && !additions.includes(entry.symbol)),
            ...additions.map((symbol) => ({ symbol, token: token++ })),
        ],
        nextToken: token,
    };
    if (!sameSymbols(previous, state.activeSymbols))
        next = leadDue(next);
    if (additions.length > 0) {
        next = { ...next, reachedEnd: false, caughtUp: liveTop ? next.caughtUp : false };
        if (next.rows.length === 0 && next.fetch.status !== 'failed')
            next = reopenInitial(next);
    }
    return sourceStatus(next);
}
export function updateMembership(state, symbols, now, adapter, config) {
    const activeSymbols = symbolSnapshot(symbols);
    if (sameSymbols(activeSymbols, state.activeSymbols))
        return state;
    const roundSymbols = state.roundSymbols.filter((symbol) => activeSymbols.includes(symbol));
    let next = {
        ...state,
        activeSymbols,
        roundSymbols,
        pending: state.pending.filter((entry) => roundSymbols.includes(entry.symbol)),
    };
    if (!sameSymbols(roundSymbols, state.roundSymbols))
        next = leadDue(next);
    next = afterEviction(state, classifyRows(next, now, false, adapter), adapter, config);
    if (!sameSymbols(roundSymbols, state.roundSymbols) &&
        next.rows.length === 0 &&
        next.roundSymbols.length > 0 &&
        next.fetch.status !== 'failed') {
        next = reopenInitial(next);
    }
    if (state.source.status === 'no-symbols' && activeSymbols.length > 0) {
        next = startRound({ ...next, source: { ...next.source, status: 'active' } }, [], false);
    }
    return next;
}
export function clearCoveredPending(state, symbols) {
    return { ...state, pending: state.pending.filter((entry) => !covers(symbols, [entry.symbol])) };
}
//# sourceMappingURL=membership.js.map